import Button from '@doordash/component-button'
import { Modal } from '@doordash/component-modal'
import {
  Icon,
  InlineChildren,
  Stack,
  StackChildren,
} from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import { VgsFieldState } from 'src/models/types'
import * as events from '../../../../../events'
import * as DA from '../../../../../typeModules/events'
// tslint:disable-next-line: max-line-length
import { Countries } from '../../../../../utilities/formatPersonalIdentificationNumber'
import t from '../../strings'
import { IdentificationDataType } from '../../types'
import { BGCForm } from './'
import { EditButtonText, InfoLabel, PersonalInfo, SectionLabel } from './styles'

type Props = {
  needsLicenseInfo: boolean
  identificationData: IdentificationDataType
  setIdentificationData: React.Dispatch<React.SetStateAction<object>>
  enableFullFormBGCEdit: boolean
  navigateToBgcForm: () => void
  vgsSsn?: VgsFieldState
}

type ReduxProps = {
  trackEditBGCInfo?: (data: DA.EditBGCInfo) => Promise<void>
}

const BGCInfoPreview: React.FC<Props & ReduxProps> = ({
  identificationData = {
    licenseNumber: '',
    licenseState: '',
    ssn: '',
    birthday: '',
  },
  needsLicenseInfo,
  setIdentificationData,
  trackEditBGCInfo,
  vgsSsn,
  navigateToBgcForm,
  enableFullFormBGCEdit,
}) => {
  const [isShowingEditModal, setIsShowingEditModal] = React.useState<boolean>(
    false
  )
  const { licenseNumber, licenseState, birthday } = identificationData

  let { ssn } = identificationData

  if (vgsSsn && vgsSsn.last4) {
    ssn = `00000${vgsSsn.last4}`
  }

  const handleClickEditButton = () => {
    trackEditBGCInfo({
      action: DA.EventActions.Clicked,
      name: DA.EditBGCInfoNames.EditButton,
      data: { enableFullFormBGCEdit },
    })
    if (enableFullFormBGCEdit) {
      navigateToBgcForm()
    }
    setIsShowingEditModal(true)
  }

  const handleCloseModal = () => {
    trackEditBGCInfo({
      action: DA.EventActions.Clicked,
      name: DA.EditBGCInfoNames.CloseButton,
    })
    setIsShowingEditModal(false)
  }

  const BGCFormModal = () => (
    <Modal
      title={t.editDetailsTitle()}
      onClose={handleCloseModal}
      isFullScreenOnMobile
    >
      <BGCForm
        needsLicenseInfo={needsLicenseInfo}
        identificationData={identificationData}
        setIdentificationData={setIdentificationData}
        setIsShowingEditModal={setIsShowingEditModal}
      />
    </Modal>
  )

  return (
    <React.Fragment>
      {isShowingEditModal && <BGCFormModal />}

      <StackChildren>
        <Stack>
          <InlineChildren
            justifyContent={InlineChildren.Justification.SpaceBetween}
            alignItems={InlineChildren.Alignment.Center}
          >
            <SectionLabel>{t.detailsPreviewTitle()}</SectionLabel>
            <Button
              onClick={handleClickEditButton}
              type={Button.Types.TertiaryPill}
              size={Button.Sizes.Small}
              isInline
            >
              <InlineChildren
                size={InlineChildren.Sizes.XSmall}
                alignItems={InlineChildren.Alignment.Center}
              >
                <Icon size={Icon.Sizes.Medium} type={Icon.Types.EditFill} />
                <EditButtonText>{t.editButtonText()}</EditButtonText>
              </InlineChildren>
            </Button>
          </InlineChildren>
        </Stack>
        {needsLicenseInfo && (
          <React.Fragment>
            <StackChildren size={StackChildren.Sizes.None}>
              <InfoLabel>{t.licenseStateLabel()}</InfoLabel>
              <PersonalInfo>{licenseState}</PersonalInfo>
            </StackChildren>
            <StackChildren size={StackChildren.Sizes.None}>
              <InfoLabel>{t.licenseNumberLabel()}</InfoLabel>
              <PersonalInfo>{licenseNumber}</PersonalInfo>
            </StackChildren>
          </React.Fragment>
        )}
        <StackChildren size={StackChildren.Sizes.None}>
          <InfoLabel>{t.birthdate()}</InfoLabel>
          <PersonalInfo>{birthday}</PersonalInfo>
        </StackChildren>
        <StackChildren size={StackChildren.Sizes.None}>
          <InfoLabel>{t.socialSecurityNumber()}</InfoLabel>
          {ssn && <PersonalInfo>{Countries.US.format(ssn, true)}</PersonalInfo>}
        </StackChildren>
      </StackChildren>
    </React.Fragment>
  )
}

const mapDispatchToProps = {
  trackEditBGCInfo: events.trackEditBGCInfo,
}

export default connect(null, mapDispatchToProps)(BGCInfoPreview)
